import { EntityInput, LinkProps } from "helpers/url";

export function letterHref(
  entity: EntityInput,
  region?: string
): LinkProps["href"] {
  const obj: LinkProps["href"] = {
    pathname: "/drugs",
    query: {},
  };

  if (entity) {
    if (entity.url) {
      const match = entity.url.match(/\/(\w+)\/(letter|eng)-([^\\/]+)/);
      /* 1 is index of first regex group in match, 0 is full match string */
      if (match && match[1] && match[2] && match[3]) {
        obj.pathname = `/${match[1]}/${match[2]}/[letter]`;
        obj.query = {
          ...((obj.query as object) || {}),
          letter: match[3],
        };
      }
    }
  }

  if (region) {
    obj.query = {
      ...((obj.query as object) || {}),
      region,
    };
  }
  return obj;
}

export function letterAs(
  entity: EntityInput,
  region?: string
): LinkProps["as"] {
  if (entity && entity.url) {
    return entity.url;
  }

  return `/drugs/${region ? `r_${region}/` : ""}`;
}
